import { v4 as uuidv4 } from 'uuid';
import BreakingBad from '../images/projects/breaking-bad.png';
import Expense from '../images/projects/expense-tracker.png';
import GreeterDapp from '../images/projects/greeter-dapp.png';
import cryptopunk from '../images/projects/cryptopunk.png';

const projects = [
  {
    id: uuidv4(),
    name: 'Cryptopunk',
    desc:
      "A modern Web 3.0 based React application to flex one's NFT collection.",
    img: cryptopunk,
    link: 'https://github.com/aniketpathak028/cryptopunk',
    demo: 'https://aniketpathak028.github.io/cryptopunk/',
  },
  {
    id: uuidv4(),
    name: 'YelpCamp',
    desc:
      "My version of Colt Steele's infamous project YelpCamp taught in his Web Development Bootcamp.",
    img:
      'https://res.cloudinary.com/practicaldev/image/fetch/s--NBm9iECO--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/i/zxl0jexucunpmlw9qtuq.png',
    link: 'https://github.com/aniketpathak028/YelpCamp-2021',
    demo: '',
  },
  {
    id: uuidv4(),
    name: 'Breaking-Bad Quiz App',
    desc: 'A Quiz application based on Breaking Bad.',
    img: BreakingBad,
    link: 'https://github.com/aniketpathak028/Breaking-Bad-Quiz-App',
    demo: 'https://aniketpathak028.github.io/Breaking-Bad-Quiz-App/',
  },
  {
    id: uuidv4(),
    name: 'Expense-Tracker App',
    desc:
      'A ReactJs based app to let users keep a track of their various yearly and monthly expenditures.',
    img: Expense,
    link: 'https://github.com/aniketpathak028/Expense-Tracker-App-React',
    demo: 'https://expensetracker2021.netlify.app/',
  },
  {
    id: uuidv4(),
    name: 'Greeter DApp',
    desc:
      'Ethereum based react app, fetches and updates data to the Ethereum network.',
    img: GreeterDapp,
    link: 'https://github.com/aniketpathak028/greeter-dapp',
    demo: 'https://aniketpathak028.github.io/greeter-dapp/',
  },
];

export default projects;
